<template>
  <div class="main-index">
    <div class="opportunity-head">
      <img class="main-img" src="~@/assets/activity/broadcast-welfare.png" />
    </div>

  </div>
</template>
<script>

export default {
    name: 'broadcastWelfare',
    methods:{
 
    },
}
</script>
<style lang="scss" scoped>
.main-img{
  width: 100%;
  min-width: 1200px
}
</style>




// WEBPACK FOOTER //
// src/gtn/views/activities/broadcast/broadcast_two.vue